import { createSelector } from 'reselect';

import { RootState } from '../reducers';
import { SidebarNames, TabsNames } from './ui.constants';

export const isFeedingListJustVisited = (state: RootState): boolean => state.ui.feedingListVisited;

export const getTabs = (state: RootState) => state.ui.tabs;

export const getOpenEditPopup = (state: RootState): string | null => state.ui.feedGroups.editGroupPropertyTooltipName;

export const getRedirectPath = (state: RootState): string | null => state.ui.preventNavigation.redirectPath || null;

export const getActiveTabIndex = createSelector(
  [getTabs, (state: RootState, tabNameSpace: TabsNames) => tabNameSpace],
  (tabList, tabNS) => (tabList[tabNS] || { activeTabIndex: 0 }).activeTabIndex,
);

export const getActiveTabName = createSelector(
  [getTabs, (state: RootState, tabNameSpace: TabsNames) => tabNameSpace],
  (tabList, tabNS) => (tabList[tabNS] || { tabName: '' }).tabName,
);

export const getSidebarState = (state: RootState, sidebarName: SidebarNames): boolean => {
  const sidebarNameRequired = state.ui.sidebars[sidebarName];
  return sidebarNameRequired ? sidebarNameRequired.isVisible : true;
};

export const isFeedingListFormChanged = (state: RootState): boolean => state.ui.feedingListFormIsChanged;
